export enum ActivityPropertyType {
  'PRIMITIVE' = 'PRIMITIVE',
  'DATE' = 'DATE',
  'TIME' = 'TIME',
  'ENUM' = 'ENUM',
  'JSON' = 'JSON',
}
